export default __webpack_public_path__ + "static/media/cover_pricing.cd195736.png";